import logo from './logo.svg';
import './App.css';
import './mobile.css';

import morning from './images/morning.webp'
import evening from './images/eve.webp'
import night from './images/night.webp'
import noon from './images/Noon.webp'

// import morning from './images/snow/morning.png'
// import evening from './images/snow/evening.png'
// import night from './images/snow/night.png'
// import noon from './images/snow/noon.png'

import React, { Component } from 'react'
import Snowfall from 'react-snowfall'


export default class App extends Component {


  render() {

    var today = new Date()
    var curHr = today.getHours()
    var time = null;


    let img = morning;
    let color = 'black'

    if (curHr > 6 && curHr < 10) {
      img = morning;
      time = 'morning'
    } else if (curHr >= 10 && curHr < 16) {
      img = noon;
      time = 'noon'
    } else if (curHr >= 16 && curHr < 18) {
      img = evening;
      color = 'white'
      time = 'evening'
    } else {
      img = night;
      color = 'white'
      time = 'night'
    }
    
    // img = evening;

    return (
      <div className='main' style={{ backgroundImage: `url(${img})` }}>

        {/* {time === 'night' ? <Snowfall /> : null} */}
        <Snowfall />

      </div>

    )
  }
}
